export default "__VITE_ASSET__qQiBWqTb__"